/* go though the normal request service with token*/
import request from '@/utils/request.js'

export default {
  /**
   * 用户登录
   * @param {username, password} params 
   * @returns
   */
  login(params = {}) {
    return request({
      url: 'api02/op01/',
      method: 'post',
      data: params
    })
  },

  /**
   * 用户退出
   * @param  {username} params
   * @returns
   */
  logout(params = {}) {
    return request({
      url: 'api02/op04/',
      method: 'post',
      data: params
    })
  },

  /**
   * 用户注册
   * @param  {form data} params
   * @returns
   */
  regist(params = {}) {
    return request({
      url: 'api02/op02/',
      method: 'post',
      data: params
    })
  },

  /**
   * 获取登录用户信息 验证token信息
   * @param  {} params
   * @returns
   */
  getInfo(params = {}) {
    return request({
      url: 'api98/',
      method: 'get',
      data: params
    })
  }
}
